export const round = (num: number, decimals: number = 0) =>
  Math.round(num * 10 ** decimals) / 10 ** decimals
